<template>
  <div class="panel-group">
    <div
      class="panel panel-default active"
      v-for="udlSection in udlSections"
      :key="udlSection.type"
      :class="panelClass(udlSection.type)">
      <div class="panel-heading">
        Strategies for {{ udlSection.type | capitalizeWords }}
      </div>
      <div class="panel-body">
        <ul class="list-unstyled">
          <li v-for="(adaptation, index) in udlSection.adaptations" :key="index">
            <p class="udl-heading"><span class="label label-info">{{ adaptation.udl_standard_checkpoint_ref }}</span> {{ udlCheckpointHeading(adaptation) }}</p>
            <WikiText
              :locked="locked"
              :plaintext="locked"
              lock-mode="always_snippet_first_block"
              :text="adaptation.text"
              :strategies="strategies" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import WikiText from '@/components/WikiText'

export default {
  name: 'UdlAdaptationPanelGroup',
  components: {
    WikiText
  },
  props: {
    udlSections: {
      type: Array,
      required: true,
      validator(value) {
        return value && value.every(section => section.type && section.adaptations)
      }
    },
    strategies: {
      type: Object,
      default() {
        return {}
      }
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    udlCheckpointHeading(adaptation) {
      return adaptation.udl_standard_short_ref.split(adaptation.udl_standard_checkpoint_ref)[1]
    },
    panelClass(udlType) {
      return `panel-default--${udlType.split(' ')[0].toLowerCase()}`
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.panel.panel-default {
  .panel-heading {
    font-size: 16px;
  }
  .panel-body {
    border-top: 1px solid #ddd;
    .udl-heading {
      font-weight: 500;
    }
  }
  .label {
    font-size: var(--text-md);
  }
  &.panel-default--engagement {
    .panel-heading {
      background: @udlEngagementLight;
    }
    .label {
      background: @udlEngagementDark;
    }
  }
  &.panel-default--action {
    .panel-heading {
      background: @udlExpressionLight;
    }
    .label {
      background: @udlExpressionDark;
    }
  }
  &.panel-default--representation {
    .panel-heading {
      background: @udlRepresentationLight;
    }
    .label {
      background: @udlRepresentationDark;
    }
  }
}
</style>
